import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import { uploadImageRequest, saveBlogRequest, removeImageRequest, fetchBlogRequestById } from "../redux/actions/blogActions";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/BlogEditor.css";
import { v4 as uuidv4 } from "uuid";
import ReCAPTCHA from "react-google-recaptcha";


const BlogEditor = () => {
  const [captchaToken, setCaptchaToken] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [content, setContent] = useState(""); // Rich text content
  const [title, setTitle] = useState(""); // Blog title
  const [tags, setTags] = useState(""); // Blog tags
  const [blogImage, setBlogImage] = useState(null); // Blog main image
  const [blogUUID , setblogUUID] = useState(null);
  const { loading, imageUploadLoading } = useSelector((state) => state.blogs);
  const editorRef = useRef(null);
  const [mystate, setmystate] = useState(0);
  const [updatedBlogContent, setupdatedBlogContent] = useState("");
  const [imageUrls, setImageUrls] = useState([]);
  const [publishedImageUrl, setPublishedImageUrl] = useState("");
  const [blogId , setBlogId] = useState(0);
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };
  useEffect(() => {
    if (id) {
      dispatch(
        fetchBlogRequestById(id, (blog) => {
          setTitle(blog.title);
          setContent(blog.content);
          setTags(blog.tags.join(", "));
          setblogUUID(blog.folder_uuid);
          setPublishedImageUrl(blog.image);
          setBlogId(blog.id);
        })
      );
    } else {
        if(!blogUUID){
          createandsetBlogUUID()
        }
    }
    if(updatedBlogContent.length>1){
      
      setContent(updatedBlogContent)
    }
    
    
  }, [blogUUID, updatedBlogContent,id]);

  const extractImageId = (url) => {
    // Example: If your image URL is something like /uploads/image123.jpg
    // and the image ID is the numeric part after 'image'
    const match = url.match(/image(\d+)/);
    return match ? match[1] : null;
  };

  const createandsetBlogUUID = async() =>{
    const newBlogId = uuidv4(); // Generate a new UUID
      setblogUUID(newBlogId); // Store the UUID in the state
  }
  

  const handleEditorChange = (content) => {
    setContent(content);
    // Extract current image URLs from editor content
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const currentImages = Array.from(doc.getElementsByTagName("img")).map((img) =>
      img.getAttribute("src")
    );

    // Find removed images
    const removedImages = imageUrls.filter((url) => !currentImages.includes(url));

    if (removedImages.length > 0) {
      // Delete removed images from server
      removedImages.forEach((url) => {
      dispatch(removeImageRequest(url));
    });
    }

    // Update the stored image URLs
    setImageUrls(currentImages);
  };
 

  // Handle Blog Main Image Upload
  const handleBlogImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        toast.error("Maximum file size can be of 10 MB");
        return;
      }
      setBlogImage(file);
      setPublishedImageUrl("");
    }
  };

  // Handle Blog Save
  const handleSaveBlog = () => {
    if (!title || !content) {
      toast.error("Please fill all mandatory fields!");
      return;
    }
    if (!captchaToken) {
      toast.error("Please complete the captcha verification.");
      return;
    }

    let bloguid = blogUUID;
    const formData = new FormData();
    formData.append("title", title);
    formData.append("content", content);
    formData.append("tags", tags);
    if(!publishedImageUrl)
    formData.append("image", blogImage);

    if (bloguid){
      formData.append("folder_uuid",blogUUID);
    }
    else{
      bloguid = uuidv4();
      formData.append("folder_uuid",bloguid);
    }
     
    if(blogId){
      formData.append("id", blogId)
    }
   
    
   if(bloguid){
   
      dispatch(
        saveBlogRequest(formData, () => {
          toast.success("Blog saved successfully!");
          navigate("/");
        })
      );
    }
    else{
      createandsetBlogUUID()
     }
  };

  const uploadAndInsertImage = (formData, editor) => {
    return new Promise((resolve, reject) => {
     // const imgHtml = `<img src="${'https://e-commerce-assets.s3.amazonaws.com/3SFELX24V628_1.webp'}" alt="Inserted Image" style="max-width:100%;height:auto;" />`;
      //editor.insertContent(imgHtml);
      dispatch(
        uploadImageRequest(formData, (response) => {
          const imageUrl = response?.data?.images?.[0];
          if (imageUrl) {
            InsertImageToEditor(imageUrl);
          } else {
            reject("Image upload failed");
          }
        })
       
      );
     
    });
  };

  const InsertImageToEditor = (imageUrl) => {
    //editorRef.current.setContent( )
    editorRef.current.selection.setContent(`<img src="${imageUrl}" alt="Inserted Image" style="max-width:100%; height:auto;" />`)
    setImageUrls((prevUrls) => [...prevUrls, imageUrl]);
   // let currentContent = 
   // currentContent += 
    setupdatedBlogContent(editorRef.current.getContent());
  };

  return mystate>=0? (

    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <ToastContainer />

      {/* Blog Main Image */}
      <div className="flex flex-col items-center mb-8">
        <label className="block text-gray-700 text-lg font-semibold">
          Upload Blog Image <span className="text-red-500">*</span>
        </label>
        <div className="mt-4">
          <input
            type="file"
            accept="image/*"
            onChange={handleBlogImageChange}
            className="hidden"
            id="blog-image"
          />
          <label
            htmlFor="blog-image"
            className="cursor-pointer flex items-center justify-center w-60 h-60 rounded-full bg-gray-100 border border-gray-300 overflow-hidden"
          >
            {blogImage ? (
              <img
                src={URL.createObjectURL(blogImage)}
                alt="Blog"
                className="w-full h-full rounded-full"
              />
            ) : publishedImageUrl ? (
              <img
                src={publishedImageUrl}
                alt="Published Blog"
                className="w-full h-full rounded-full"
              />
            ): (
              <span className="text-gray-400 text-sm text-center">Click to Upload the main Blog's Image</span>
            )}
          </label>
        </div>
      </div>

      {/* Title */}
      <div className="mb-6">
        <label className="block text-gray-700 text-lg font-semibold">
          Title <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          className="border border-gray-300 p-3 w-full rounded mt-2"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter your blog title..."
        />
      </div>

      {/* Tags */}
      <div className="mb-6">
        <label className="block text-gray-700 text-lg font-semibold">Tags</label>
        <input
          type="text"
          className="border border-gray-300 p-3 w-full rounded mt-2"
          value={tags}
          onChange={(e) => setTags(e.target.value)}
          placeholder="Enter tags, separated by commas..."
        />
      </div>

      {/* Content */}
      <div className="mb-6">
        <label className="block text-gray-700 text-lg font-semibold">
          Content <span className="text-red-500">*</span>
        </label>

        <Editor
          apiKey="am156e5ke2z5yn5kq0jepgaoql2h8q5l34bgyq9p0be2n0pi"
          value={content}
          ref={editorRef}
          onEditorChange={handleEditorChange}//onEditorChange={(newContent) => setContent(newContent)}
          onInit={(evt, editor) => (editorRef.current = editor)}
          init={{
            height: 500,
            menubar: true, // Set menubar to true if needed
            plugins: [
              "advlist autolink lists link image charmap print preview anchor",
              "searchreplace visualblocks code fullscreen",
              "insertdatetime media table paste code help wordcount"
            ],
            toolbar:
              "undo redo | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | myimage | help",
            //images_upload_handler: handleImageUpload,
            setup: (editor) => {
              editorRef.current = editor;
              editor.ui.registry.addButton("myimage", {
                icon: "image",
                tooltip: "Upload Image",
                onAction: () => {
                  const input = document.createElement("input");
                  input.type = "file";
                  input.accept = "image/*";
                  input.click();
                  input.onchange = async (e) => {
                    const file = e.target.files[0];
                    const formData = new FormData();
                    formData.append("images", file);
                    formData.append("fileName", file.name);
                    formData.append("folder_uuid", blogUUID);
                   
                    try{
                       // Upload the image and insert into the editor
                       if(blogUUID){
                        await uploadAndInsertImage(formData, editor);
                       }
                       else{
                        createandsetBlogUUID()
                       }
                        

                    }
                    catch(e){ 
            
                    }
                   
                  };
                },
              });
            },
            branding: false,
            
          }}
        />
      </div>

      {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
          <div className="mb-4">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
            />
          </div>
          ):null}
      {/* Save Button */}
      <button
        onClick={handleSaveBlog}
        className={`w-full py-2 text-white bg-black rounded-xl hover:bg-gray-900 transition  ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        disabled={loading}
      >
        {loading? id? "Updating..." : "Saving..." : id ? "Update Blog" : "Save Blog"}
      </button>

      {/* Loader */}
      {(loading || imageUploadLoading) && (
        <div className="mt-4 text-blue-500 text-center">Processing...</div>
      )}
    </div>
  ) : (<></>);
};

export default BlogEditor;
